import { render } from "./FlowItem.vue?vue&type=template&id=050f2250&scoped=true"
import script from "./FlowItem.vue?vue&type=script&lang=js"
export * from "./FlowItem.vue?vue&type=script&lang=js"

import "./FlowItem.vue?vue&type=style&index=0&id=050f2250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050f2250"]])

export default __exports__